var _circle, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 166,
    viewBox: "0 0 141 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.959,
    r: 70,
    fill: "#F1F1F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.955223,
    y: 1.03275,
    width: 69.6732,
    height: 88.1597,
    rx: 7,
    transform: "matrix(1.0036 0.0392857 -0.0483802 0.993467 43.0416 62.7905)",
    fill: "#EEEEEE",
    stroke: "#999999",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1.13839,
    y: -0.872169,
    width: 73.8796,
    height: 91.8422,
    rx: 9,
    transform: "matrix(0.993106 -0.117221 0.145284 0.98939 3.57687 59.1298)",
    fill: "#FAFAFA",
    stroke: "#999999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62028 67.1876C3.97837 62.8162 7.01504 58.8526 11.4029 58.3347L66.8972 51.7845C71.285 51.2665 75.3624 54.3904 76.0043 58.7618L77.8441 71.2912L6.46011 79.7169L4.62028 67.1876Z",
    fill: "#EEEEEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.69527,
    height: 9.98327,
    rx: 1.34763,
    transform: "matrix(0.145284 0.98939 -0.993106 0.117221 90.3662 53.5361)",
    fill: "#999999"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.99498,
    height: 8.98422,
    rx: 1.49749,
    transform: "matrix(0.993106 -0.117221 0.145284 0.98939 62.9697 38.6836)",
    fill: "#999999"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.84907,
    height: 9.49689,
    rx: 1.42453,
    transform: "matrix(0.835382 0.574705 -0.641011 0.74897 80.5469 41.1309)",
    fill: "#999999"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 57.903,
    height: 3.59369,
    rx: 1.79684,
    transform: "matrix(0.993106 -0.117221 0.145284 0.98939 13.9219 82.4541)",
    fill: "#DCDCDC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 57.903,
    height: 3.59369,
    rx: 1.79684,
    transform: "matrix(0.993106 -0.117221 0.145284 0.98939 16.5332 100.231)",
    fill: "#DCDCDC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 57.903,
    height: 3.59369,
    rx: 1.79684,
    transform: "matrix(0.993106 -0.117221 0.145284 0.98939 19.1436 118.009)",
    fill: "#DCDCDC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 20.9649,
    height: 3.59369,
    rx: 1.79684,
    transform: "matrix(0.993106 -0.117221 0.145284 0.98939 14.9668 89.5645)",
    fill: "#EEEEEE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 20.9649,
    height: 3.59369,
    rx: 1.79684,
    transform: "matrix(0.993106 -0.117221 0.145284 0.98939 17.5771 107.343)",
    fill: "#EEEEEE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 20.9649,
    height: 3.59369,
    rx: 1.79684,
    transform: "matrix(0.993106 -0.117221 0.145284 0.98939 20.1875 125.12)",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.b9cf7effeebf02eeb61a87b0a71d6268.svg";
export { ForwardRef as ReactComponent };